import React, { useState } from 'react';

import { Loading } from '@components/Gui/Loading';
import NwDrawer from '@components/Gui/NwDrawer';
import TransactionDetails from '@components/Transactions/TransactionsDrawer/TransactionDetails';

const TransactionDetailDrawer = ({
    transaction,
    projectId,
    onClose,
    onUpdateTransaction,
    onTransactionRemoved,
    hideProject,
}) => {
    const [touchForm, setTouchForm] = useState(false);
    return (
        <NwDrawer
            touchForm={touchForm}
            onTouchForm={setTouchForm}
            onClose={onClose}
            title="Transaction Details"
            width="60vw"
            maxWidth="60rem"
            minWidth="40rem"
        >
            {transaction ? (
                <TransactionDetails
                    hideProject={hideProject}
                    projectId={projectId}
                    transaction={transaction}
                    onUpdateTransaction={onUpdateTransaction}
                    onTouchForm={setTouchForm}
                    onTransactionRemoved={onTransactionRemoved}
                />
            ) : (
                <Loading />
            )}
        </NwDrawer>
    );
};

export default TransactionDetailDrawer;
